import { toast } from "react-toastify";
import { AI_SCHEDULE_MATRIX_GROUP } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

const buildQueryUrl = (base, params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.append(key, String(value));
  });
  const qs = search.toString();
  return qs ? `${base}?${qs}` : base;
};

export const fetchAIScheduleMatrixGroupTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(AI_SCHEDULE_MATRIX_GROUP.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getAIScheduleMatrixGroupList = async (data = {}) => {
  try {
    const url = buildQueryUrl(AI_SCHEDULE_MATRIX_GROUP.LIST, data);
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitAIScheduleMatrixGroupFilterData = async (data = {}) => {
  try {
    const response = await POST(AI_SCHEDULE_MATRIX_GROUP.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addAIScheduleMatrixGroup = async (data = {}) => {
  try {
    const response = await POST(AI_SCHEDULE_MATRIX_GROUP.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateAIScheduleMatrixGroup = async (id, data = {}) => {
  try {
    const response = await PUT(AI_SCHEDULE_MATRIX_GROUP.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getAIScheduleMatrixGroupById = async (data = {}) => {
  try {
    const url = data?.Id
      ? AI_SCHEDULE_MATRIX_GROUP.BY_ID(data.Id)
      : AI_SCHEDULE_MATRIX_GROUP.LIST;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
